import { c as _c } from "react/compiler-runtime";
import { Dialog } from "@flat-ui";
import { createContext, useCallback, useContext, useRef, useState } from "react";
/** A dialog context which provides the components with the function to create a dialog */
const DialogContext = createContext(undefined);

/**
 *  @returns A dialog provider which allows the components to create a dialog from anywhere
 */
export function SphereDialogProvider(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const confirmPromiseRef = useRef(undefined);
  const [dialogOptions, setDialogOptions] = useState(null);
  const [content, setContent] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async (options, content_0) => {
      setDialogOptions(options);
      setContent(content_0 ?? "");
      return new Promise(resolve => {
        confirmPromiseRef.current = {
          resolve
        };
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const createDialog = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = shouldConfirm => {
      if (shouldConfirm !== undefined && confirmPromiseRef.current) {
        confirmPromiseRef.current.resolve(shouldConfirm);
      }
      setDialogOptions(null);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeDialog = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function handleCancel() {
      if (confirmPromiseRef.current) {
        confirmPromiseRef.current.resolve(false);
      }
      setDialogOptions(null);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleCancel = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function handleConfirm() {
      if (confirmPromiseRef.current) {
        confirmPromiseRef.current.resolve(true);
      }
      setDialogOptions(null);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleConfirm = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      createDialog,
      closeDialog
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== content || $[6] !== dialogOptions) {
    t6 = dialogOptions && <Dialog open={!!dialogOptions} onConfirm={dialogOptions?.isHideConfirm ? undefined : handleConfirm} onClose={dialogOptions?.isHideClose ? undefined : handleCancel} onCancel={dialogOptions?.isHideCancel ? undefined : handleCancel} {...dialogOptions}>{content}</Dialog>;
    $[5] = content;
    $[6] = dialogOptions;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children || $[9] !== t6) {
    t7 = <DialogContext.Provider value={t5}>{t6}{children}</DialogContext.Provider>;
    $[8] = children;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}

/**
 * @returns Hook that returns the utility function to create a dialog
 */
export function useSphereDialog() {
  const ctx = useContext(DialogContext);
  if (!ctx) {
    throw Error("useSphereDialog called outside the SphereDialogContext");
  }
  return ctx;
}